<template>
  <nav class="c-bread">
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <a v-if=" item.url !== undefined" :href="item.url">{{ item.name }}</a>
        <span v-else>{{ item.name }}</span>
      </li>
    </ul>
    <!-- <script v-html="jsonld" type="application/ld+json"></script> -->
  </nav>
</template>

<script>
export default {
  name: 'CommonBreadcrumb',
  props: ['breadcrumbType', 'heading', 'name', 'prop_name', 'pref_name'],
  data() {
    return {
      initialized: false,
      jsonld: {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            item: {
              '@id': '/',
              name: 'KEIAIミツカル[不動産/住宅]',
            },
          },
        ],
      },
      list: [
        {
          name: 'KEIAIミツカル[不動産/住宅]',
          url: '/',
        },
      ],
    };
  },
  computed: {
    storedLocation() {
      return this.$store.getters['getLocation'];
    },
    storedProp() {
      return this.$store.getters['getProp'];
    },
  },
  metaInfo() {
    return this.initialized ? this.jsonldExport(this.jsonld) : null;
    // return null;
  },
  async mounted() {
    this.location = await this.storedLocation;
    let name;
    let url;
    if (this.breadcrumbType === 'searchList') {
      name = '一戸建て';
      url = '/kodate/';
      this.prop = await this.storedProp;
      this.list.push({ name, url });
      this.addJsonLd(name, url);
      if (this.$route.meta.kind) {
        if (this.$route.meta.kind === 1) {
          name = '新築一戸建て';
          url = '/kodate/shinchiku/';
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          if (this.location.city.name === null) {
            name = `${this.location.pref.name} の一戸建て物件一覧`;
            this.list.push({ name });
            // this.addJsonLd(name);
          } else {
            name = this.location.pref.name;
            url = `/kodate/shinchiku/area/${this.location.pref.code}/`;
            this.list.push({ name, url });
            this.addJsonLd(name, url);
            if (this.location.town.name === null) {
              name = `${this.location.city.name} の一戸建て物件一覧`;
              this.list.push({ name });
              // this.addJsonLd(name);
            } else {
              name = this.location.city.name;
              url = `/kodate/shinchiku/area/${this.location.pref.code}/${this.location.city.code}/`;
              this.list.push({ name, url });
              this.addJsonLd(name, url);
              name = `${this.location.town.name} の一戸建て物件一覧`;
              this.list.push({ name });
              // this.addJsonLd(name);
            }
          }
        }
        if (this.$route.meta.kind === 2) {
          name = '中古一戸建て';
          url = '/kodate/chuko/';
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          if (this.location.city.name === null) {
            name = `${this.location.pref.name} の一戸建て物件一覧`;
            this.list.push({ name });
            // this.addJsonLd(name);
          } else {
            name = this.location.pref.name;
            url = `/kodate/chuko/area/${this.location.pref.code}/`;
            this.list.push({ name, url });
            this.addJsonLd(name, url);
            if (this.location.town.name === null) {
              name = `${this.location.city.name} の一戸建て物件一覧`;
              this.list.push({ name });
              // this.addJsonLd(name);
            } else {
              name = this.location.city.name;
              url = `/kodate/chuko/area/${this.location.pref.code}/${this.location.city.code}/`;
              this.list.push({ name, url });
              this.addJsonLd(name, url);
              name = `${this.location.town.name} の一戸建て物件一覧`;
              this.list.push({ name });
              // this.addJsonLd(name);
            }
          }
        }
      } else if (!this.$route.meta.kind) {
        if (this.location.city.name === null) {
          name = `${this.location.pref.name} の一戸建て物件一覧`;
          this.list.push({ name });
          // this.addJsonLd(name);
        } else {
          name = this.location.pref.name;
          url = `/kodate/area/${this.location.pref.code}/`;
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          if (this.location.town.name === null) {
            name = `${this.location.city.name} の一戸建て物件一覧`;
            this.list.push({ name });
            // this.addJsonLd(name);
          } else {
            name = this.location.city.name;
            url = `/kodate/area/${this.location.pref.code}/${this.location.city.code}/`;
            this.list.push({ name, url });
            this.addJsonLd(name, url);
            name = `${this.location.town.name} の一戸建て物件一覧`;
            this.list.push({ name });
            // this.addJsonLd(name);
          }
        }
      }
    } else if (this.breadcrumbType === 'schoolList') {
      this.prop = this.storedProp;
      if (this.location.city.name === null) {
        name = `${this.location.pref.name} の学校一覧`;
        this.list.push({ name });
        // this.addJsonLd(name);
      } else {
        name = this.location.pref.name;
        url = `/kodate/area/${this.location.pref.code}/`;
        this.list.push({ name, url });
        this.addJsonLd(name, url);
        name = `${this.location.city.name} の学校一覧`;
        this.list.push({ name });
        // this.addJsonLd(name);
      }
    } else if (this.breadcrumbType === 'detail') {
      name = '一戸建て';
      url = '/kodate/';
      this.list.push({ name, url });
      this.addJsonLd(name, url);
      if (this.storedProp.kind) {
        if (this.storedProp.kind === 'newly-house') {
          name = '新築一戸建て';
          url = '/kodate/shinchiku/';
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          name = this.location.pref.name;
          url = `/kodate/shinchiku/area/${this.location.pref.code}/`;
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          name = this.location.city.name;
          url = `/kodate/shinchiku/area/${this.location.pref.code}/${this.location.city.code}/`;
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          if (this.location.town.name !== '' && this.location.town.name) {
            name = this.location.town.name;
            url = `/kodate/shinchiku/area/${this.location.pref.code}/${this.location.city.code}/${this.location.town.code}/`;
            this.list.push({ name, url });
            this.addJsonLd(name, url);
          }
        }
        if (this.storedProp.kind === 'second-hand-house') {
          name = '中古一戸建て';
          url = '/kodate/chuko/';
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          name = this.location.pref.name;
          url = `/kodate/chuko/area/${this.location.pref.code}/`;
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          name = this.location.city.name;
          url = `/kodate/chuko/area/${this.location.pref.code}/${this.location.city.code}/`;
          this.list.push({ name, url });
          this.addJsonLd(name, url);
          if (this.location.town.name !== '' && this.location.town.name) {
            name = this.location.town.name;
            url = `/kodate/chuko/area/${this.location.pref.code}/${this.location.city.code}/${this.location.town.code}/`;
            this.list.push({ name, url });
            this.addJsonLd(name, url);
          }
        }
      } else if (!this.storedProp.kind) {
        name = this.location.pref.name;
        url = `/kodate/area/${this.location.pref.code}/`;
        this.list.push({ name, url });
        this.addJsonLd(name, url);
        name = this.location.city.name;
        url = `/kodate/area/${this.location.pref.code}/${this.location.city.code}/`;
        this.list.push({ name, url });
        this.addJsonLd(name, url);
        if (this.location.town.name !== '' && this.location.town.name) {
          name = this.location.town.name;
          url = `/kodate/area/${this.location.pref.code}/${this.location.city.code}/${this.location.town.code}/`;
          this.list.push({ name, url });
          this.addJsonLd(name, url);
        }
      }
      name = `${this.prop_name}`;
      this.list.push({ name });
      // this.addJsonLd(name);
    } else if (this.breadcrumbType === 'favorite') {
      name = 'お気に入り';
      this.list.push({ name });
      // this.addJsonLd(name);
    } else if (this.breadcrumbType === 'default' && this.heading) {
      name = this.heading;
      this.list.push({ name });
      // this.addJsonLd(name);
    } else if (this.breadcrumbType === 'mainKind') {
      if (this.$route.meta.kind === 0) {
        name = '一戸建て';
        url = '/kodate/';
        this.list.push({ name });
        // this.addJsonLd(name);
      } else if (this.$route.meta.kind === 1) {
        name = '一戸建て';
        url = '/kodate/';
        this.list.push({ name, url });
        this.addJsonLd(name, url);
        name = '新築一戸建て';
        this.list.push({ name });
        // this.addJsonLd(name);
      } else if (this.$route.meta.kind === 2) {
        name = '一戸建て';
        url = '/kodate/';
        this.list.push({ name, url });
        this.addJsonLd(name, url);
        name = '中古一戸建て';
        this.list.push({ name });
        // this.addJsonLd(name);
      }
    }
    this.initialized = true;
  },
  methods: {
    addJsonLd(name, id = null) {
      let jsonld = {};
      if (id !== null) {
        jsonld = {
          '@type': 'ListItem',
          position: this.jsonld.itemListElement.length + 1,
          item: {
            '@id': id,
            name,
          },
        };
      } else {
        jsonld = {
          '@type': 'ListItem',
          position: this.jsonld.itemListElement.length + 1,
          item: {
            name,
          },
        };
      }
      this.jsonld.itemListElement.push(jsonld);
    },
    jsonldExport(params) {
      return {
        script: [
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify(params, null, 2,
            ),
          },
        ],
      };
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->

<style lang='scss' scoped>
@charset 'UTF-8';
.c-bread {
  display: flex;
  width: calc(100% - 40px);
  margin: 20px;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      line-height: 1.7em;
      margin-left: 4px;
      a {
        font-size: 13px;
        color: #E83532;
      }
      span {
        font-size: 13px;
      }
    }
    li:not(:first-child)::before {
      content: "> ";
      margin-left: 4px;
    }
  }
  &--icon {
    width: 50px;
  }
}
</style>
